{
  "_provenance": {
    "ns": "community",
    "source": "pages/CommunityPage.tsx and components/community/** outside R2’s poll files (#2109 R3 lane L6)"
  },
  "author": {
    "announcement": "From TRF",
    "anonymous": "A TRF family"
  },
  "card": {
    "pinned": "Pinned",
    "readMore": "Read more",
    "showLess": "Show less"
  },
  "filter": {
    "when": {
      "any": "Any time",
      "label": "When",
      "month": "This month",
      "older": "Older",
      "week": "This week"
    }
  },
  "groups": {
    "empty": "TRF hasn’t listed any groups yet.",
    "intro": "Groups run by organisations TRF trusts. They are not run by TRF, and what you share there stays with them.",
    "join": "Join group",
    "joinWhatsApp": "Join on WhatsApp",
    "loadError": "Couldn’t load the list right now.",
    "open": "Open",
    "title": "Where families already talk",
    "trfIntro": "Groups TRF runs. A TRF staff member is an admin in each one.",
    "trfTitle": "TRF groups"
  },
  "page": {
    "empty": {
      "announcementsBody": "TRF posts news, celebrations and polls here.",
      "narrowed": "Nothing here for that search or time.",
      "noneTitle": "Nothing here yet."
    },
    "filterLabel": "Filter announcements",
    "loadError": "Couldn’t load announcements",
    "searchPlaceholder": "Search announcements"
  },
  "poll": {
    "anonymousLabel": "Anonymous poll",
    "anonymousNote": "Anonymous — even TRF only sees totals",
    "answerPlaceholder": "Your answer…",
    "closing": {
      "afterClose": "Thanks — results will be shown when this poll closes.",
      "afterCloseOn": "Thanks — results will be shown when this poll closes on {{date}}.",
      "shared": "Thanks for sharing.",
      "withheld": "Thanks — your answers went to your TRF team."
    },
    "error": {
      "answerOne": "Answer at least one question before submitting.",
      "answerQuestion": "Answer “{{prompt}}” before submitting.",
      "checkQuestion": "Check “{{prompt}}” before submitting.",
      "date": "Enter a valid date.",
      "max": "Enter {{max}} or less.",
      "min": "Enter {{min}} or more.",
      "needsAnswer": "This question needs an answer.",
      "number": "Enter a number.",
      "saveFailed": "We couldn’t send your answers, so they have not been saved. Please check your connection and try again."
    },
    "eyebrow": "TRF POLL",
    "submit": "Submit",
    "vote": "Vote"
  },
  "reaction": {
    "added": "{{label}} added",
    "celebrate": "Celebrate",
    "heart": "Heart",
    "hug": "Hug",
    "removed": "{{label}} removed",
    "withCount": "{{label}} · {{n}}"
  },
  "status": {
    "pending": "Waiting for TRF to read it",
    "removed": "Not published",
    "visible": "Live"
  },
  "toast": {
    "reactAddFailed": "Couldn’t add your reaction",
    "reactRemoveFailed": "Couldn’t remove your reaction"
  }
}
